import { Record as ImmutableRecord, Map as ImmutableMap } from 'immutable';
import * as AuditEventSubTypes from 'automation-ui-management/records/AuditHistory/AuditEventSubTypes';
export const AuditEventActionMetadataKeys = {
  ADDED_COUNT: 'addedCount',
  EDITED_COUNT: 'editedCount',
  DELETED_COUNT: 'deletedCount'
};
export default class AuditEventActionMetadata extends ImmutableRecord({
  [AuditEventActionMetadataKeys.ADDED_COUNT]: 0,
  [AuditEventActionMetadataKeys.EDITED_COUNT]: 0,
  [AuditEventActionMetadataKeys.DELETED_COUNT]: 0
}) {
  constructor(props) {
    const propMap = ImmutableMap(props);
    super(propMap);
  }
  updateCountBasedOnEventSubType(auditEventSubType, amount) {
    switch (auditEventSubType) {
      case AuditEventSubTypes.ADDED_ACTION:
        return this.increaseAdded(amount);
      case AuditEventSubTypes.EDITED_ACTION:
        return this.increaseEdited(amount);
      case AuditEventSubTypes.DELETED_ACTION:
        return this.increaseDeleted(amount);
      default:
        return this;
    }
  }
  increaseAdded(amount) {
    return this.update(AuditEventActionMetadataKeys.ADDED_COUNT, value => value + amount);
  }
  increaseEdited(amount) {
    return this.update(AuditEventActionMetadataKeys.EDITED_COUNT, value => value + amount);
  }
  increaseDeleted(amount) {
    return this.update(AuditEventActionMetadataKeys.DELETED_COUNT, value => value + amount);
  }
  getAddedCount() {
    return this[AuditEventActionMetadataKeys.ADDED_COUNT];
  }
  getEditedCount() {
    return this[AuditEventActionMetadataKeys.EDITED_COUNT];
  }
  getDeletedCount() {
    return this[AuditEventActionMetadataKeys.DELETED_COUNT];
  }
  mergeAuditEventActionMetadata(auditEventActionMetadata) {
    return this.update(AuditEventActionMetadataKeys.ADDED_COUNT, value => value + auditEventActionMetadata.getAddedCount()).update(AuditEventActionMetadataKeys.EDITED_COUNT, value => value + auditEventActionMetadata.getEditedCount()).update(AuditEventActionMetadataKeys.DELETED_COUNT, value => value + auditEventActionMetadata.getDeletedCount());
  }
}